// https://mui.com/material-ui/customization/default-theme/?expand-path=$.palette.primary
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "rgb(1, 47, 77)",
      mainHoverLight: "rgb(25, 66, 124)",
      mainHoverNav: "rgb(5, 69, 160)",
      superlight: "rgba(230, 243, 255, 0.3)",
      superlight2: "rgb(213, 229, 245)",
      superlight3: "rgb(242, 251, 255)",
      light: "#173763",
      dark: "#001332",
      saturated: "#002B72",
      disabled: "rgb(116, 135, 148)",
    },
    secondary: {
      main: "rgb(208, 158, 40)",
      light: "rgb(220, 175, 71)",
      dark: "rgb(201, 147, 20)",
      saturated: "rgb(227, 169, 36)",
      background: "rgb(255, 247, 230)",
      contrastText: "rgb(252, 248, 248)",
    },
    info: {
      main: "#02BDD1",
      lighter: "#BCE9E4",
      background: "rgb(240, 251, 255)",
    },
    error: {
      main: "#d32f2f",
      lighter: "#E9BDBC",
      background: "rgb(255, 240, 240)",
      background2: "rgb(255, 249, 249)",
      superlight: "rgb(244, 216, 216)",
    },
    warning: {
      main: "#ed6c02",
      lighter: "#E9CDBC",
      background: "#FFF7EE",
    },
    success: {
      main: "rgb(29, 180, 89)",
      lighter: "rgba(197, 222, 205, 1)",
      // dark: '#5F6F41',
      background: "#EDFFEA",
      background2: "rgb(241, 247, 243)",
      contrastText: "#F0F0F0",
    },
    background: {
      default: "#f7f7f7",
      lighter: "rgb(250, 250, 250)",
      paper: "#ffffff",
      darker: "rgb(245, 245, 245)",
    },
    // text: {
    //     primary: '#ffffff',
    // },
    divider: "#e0e0e0",
    action: {
      hover: "rgba(255, 255, 255, 0.05)",
    },
  },

  typography: {
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    h1: {
      fontFamily: `"Mercury", "Georgia", "Times", serif`,
      fontWeight: 500,
      fontSize: "3.5em",
    },
    h2: {
      fontFamily: `"Mercury", "Georgia", "Times", serif`,
      fontWeight: 500,
      fontSize: "2.5em",
      "@media (max-width:600px)": {
        fontSize: "2em",
      },
    },
    h3: {
      fontFamily: `"Mercury", "Georgia", "Times", serif`,
      fontWeight: 500,
      fontSize: "1.8em",
      "@media (max-width:600px)": {
        fontSize: "1.6em",
      },
    },
    h4: {
      fontFamily: `"Mercury", "Georgia", "Times", serif`,
      fontWeight: 500,
      fontSize: "1.5em",
    },
    h5: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    h6: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    subtitle1: {},
    subtitle2: {},
    body1: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    body2: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    button: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
      textTransform: "none",
    },
  },

  spacing: (factor) => `${0.5 * factor}rem`,

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "rgba(230, 243, 255, 0.3)",
        },
      },
    },

    MuiContainer: {
      defaultProps: {
        maxWidth: "lg",
      },
    },

    MuiLink: {
      styleOverrides: {
        root: {
          color: "#f0f0f0",
          "&:visited": {
            color: "#f0f0f0",
          },
        },
      },
    },

    MuiPaper: {
      defaultProps: {
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          borderRadius: 12, // Set your desired border-radius for Paper components
          border: "1px solid rgb(226, 234, 243)",
        },
      },
    },
    MuiPopover: {
      // Language selector
      styleOverrides: {
        paper: {
          borderRadius: 8,
          marginTop: 4,
        },
      },
    },

    MuiAppBar: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: ({ theme }) => ({
          borderBottom: `1px solid ${theme.palette.divider}`,
        }),
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgb(212, 224, 238)", // Change this to your desired default border color
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 2, // Remove left margin
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 12, // Set your desired border-radius for Alerts
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&:hover": {
            backgroundColor: theme.palette.primary.superlight,
          },
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.superlight2,

            // '&:hover': {
            //     backgroundColor: theme.palette.primary.superlight2,
            // },
          },
          "&.Mui-selected.Mui-focusVisible": {
            backgroundColor: theme.palette.primary.superlight2,
            outline: "none",
          },
          "&.Mui-focusVisible": {
            backgroundColor: theme.palette.primary.superlight,
            outline: "none",
          },
        }),
      },
    },
  },
});

export default theme;
